import { Select } from "../../../../components/forms/select";
import { useCountries } from "../../../products/hooks/useCountries";

interface CountryOfOriginSelectProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function CountryOfOriginSelect({
  value,
  onChange,
  error,
}: CountryOfOriginSelectProps) {
  const { data: countries, isLoading } = useCountries();

  const options =
    countries?.map((country) => ({
      value: country.id.toString(),
      label: country.name,
    })) ?? [];

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onChange(e.target.value);
  };

  return (
    <Select
      label="Country"
      name="countryOfOriginId"
      value={value}
      onChange={handleChange}
      placeholder="Select a country"
      disabled={isLoading}
      options={options}
      error={error}
      helperText={isLoading ? "Loading countries..." : ""}
    />
  );
}
